import { useEffect, useState } from "react";
import { useIntent } from "@/context/IntentContext";

/**
 * Floating bottom bar on mobile only. Appears after scrolling past hero.
 * Triggers Intent Selector modal.
 */
export function MobileCTABar() {
  const { open, isOpen } = useIntent();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > window.innerHeight * 0.5);
    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  if (isOpen) return null;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 p-3 transition-all duration-300"
      style={{
        background: "linear-gradient(180deg, transparent 0%, rgba(20,18,40,0.95) 30%)",
        transform: visible ? "translateY(0)" : "translateY(120%)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      <button
        onClick={open}
        className="w-full px-4 py-3.5 font-bold uppercase tracking-[0.12em] text-[12px] text-white transition-all"
        style={{
          background: "linear-gradient(135deg, #b87800, #b87800)",
          boxShadow: "0 0 28px rgba(42, 74, 158, 0.5), 0 8px 24px rgba(0,0,0,0.4)",
        }}
      >
        Get Started Free <span className="ml-1">{"\u2192"}</span>
      </button>
    </div>
  );
}
